/**
 * @type {import('tailwindcss').Config}
 */
export default {
  content: ['./resources/**/*.blade.php', './frontend/**/*.js', './frontend/**/*.ts', './frontend/**/*.tsx'],
  theme: {
    extend: {
      screens: {
        xs: '320px',
        // => @media (min-width: 320px) { ... }
        sm: '640px',
        // => @media (min-width: 640px) { ... }
        md: '768px',
        // => @media (min-width: 768px) { ... }
        lg: '1024px',
        // => @media (min-width: 1024px) { ... }
        xl: '1280px',
        // => @media (min-width: 1280px) { ... }
        '2xl': '1536px',
        // => @media (min-width: 1536px) { ... }
      },
      fontFamily: {
        body: [
          'MyYuGothicM',
          '游ゴシック',
          'Yu Gothic',
          'YuGothic',
          'ヒラギノ角ゴ ProN',
          'Hiragino Kaku Gothic ProN',
          'MS メイリオ',
          'Meiryo',
          'sans-serif',
        ],
      },
      colors: {
        rf: {
          navy: '#00375F',
          blue: '#119CDA',
          red: '#E1323C',
          yellow: '#F3C82D',
          black: '#191919',
          white: '#ffffff',
        },
        gray: {
          '01': '#F7F7F7',
          '02': '#D5D5D5',
          '03': '#A2A2A2',
          '04': '#808080',
        },
        sns: {
          youtube: '#FF0000',
          facebook: '#1877F2',
          instagram: '#D6025E',
          line: '#07C757',
          pinterest: '#E6001A',
        },
      },
      fontSize: {
        '2xs': ['0.625rem', '0.75rem'],
        xs: ['0.75rem', '1rem'],
        sm: ['0.875rem', '1.25rem'],
        base: ['1rem', '1.5rem'],
        lg: ['1.125rem', '1.75rem'],
        xl: ['1.25rem', '1.75rem'],
        '2xl': ['1.5rem', '2rem'],
        '3xl': ['1.875rem', '2.25rem'],
        '4xl': ['2.25rem', '2.5rem'],
        '5xl': ['3rem', '1'],
        '6xl': ['3.75rem', '1'],
        '7xl': ['4.5rem', '1'],
        '8xl': ['6rem', '1'],
        '9xl': ['8rem', '1'],
      },
      letterSpacing: {
        tighter: '-.05em',
        tight: '-.025em',
        normal: '0',
        wide: '.025em',
        wider: '.05em',
        widest: '.1em',
        '2xl': '.25em',
      },
      lineHeight: {
        5.5: '1.375rem',
      },
    },
  },
  plugins: [],
  important: true,
};
